import React from "react";
import { UI_BODY_SEMIBOLD_DF, UI_DISPLAY, UI_CAPTION, TooltipV2 } from "oolib";
import { Tag } from "oolib/dist/v2/components/Tags";
import { StyledMetricCardContainer, StyledTagsContainer, StyledTooltipBox, StyledTooltipContent } from "./styled";
import { AllActiveFilter } from "../types";

export interface MetricCardProps {
  display: string;
  title?: string;
  tagDisplay?: string;
  style?: React.CSSProperties;
  allActiveFilters?: AllActiveFilter[];
  tooltipContent?: {
    textLabel: string;
    content: React.ReactNode;
  };
}

export const MetricCard: React.FunctionComponent<MetricCardProps> = ({
  display,
  title,
  tagDisplay,
  allActiveFilters,
  style,
  tooltipContent,
}) => {

  const filters = allActiveFilters?.map(filter => ({
    label: filter.display || 'Filter',
    values: Array.isArray(filter.values)
      ? filter.values.map(v => v?.display || v)
      : []
  })) || [];

  const filterCount = filters.length;

  const filterTooltipContent = {
    layout: 'custom' as const,
    render: (
      <StyledTooltipBox>
        {filters?.map((filter, index) => (
          <StyledTooltipContent key={index} $isLast={index === filters.length - 1}>
            <UI_CAPTION>{filter.label}</UI_CAPTION>
            {filter.values.map((value, vIndex) => (
              <UI_CAPTION key={vIndex}>{value}</UI_CAPTION>
            ))}
          </StyledTooltipContent>
        ))}
      </StyledTooltipBox>
    )
  };

  return (
    <StyledMetricCardContainer style={style}>
      <UI_DISPLAY>{display}</UI_DISPLAY>
      {title && <UI_BODY_SEMIBOLD_DF>{title}</UI_BODY_SEMIBOLD_DF>}
      <StyledTagsContainer>
        {tagDisplay && (
          <Tag
            display={tagDisplay}
            fill="outline"
            size="XS"
          />
        )}
        {filterCount > 0 && (
          <TooltipV2 primaryContent={filterTooltipContent} trigger="click" placement="bottom">
            <Tag
              display={`${filterCount} Filter${filterCount > 1 ? 's' : ''} Applied`}
              fill="outline"
              size="XS"
            />
          </TooltipV2>
        )}
        {tooltipContent && (
          <TooltipV2
            primaryContent={{ layout: 'custom' as const, render: <StyledTooltipBox>{tooltipContent.content}</StyledTooltipBox> }}
            trigger="click"
            placement="bottom"
          >
            <UI_CAPTION style={{ cursor: "pointer", textDecoration: "underline", opacity: 0.6 }}>
              {tooltipContent.textLabel}
            </UI_CAPTION>
          </TooltipV2>
        )}
      </StyledTagsContainer>
    </StyledMetricCardContainer>
  );
};


